export const convertMoneyFormatToNumber = (money: string): number =>
  parseFloat(money.replace('.', '').replace(',', '.'))

export const convertNumberToMoneyFormat = (num: number): string =>
  num.toFixed(2).replace('.', ',')
